// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-icon {
  height: 15px;
  font-size: 16px;
  vertical-align: middle;
}

ion-text {
  margin-top: 12px;
  display: block;
}

.container-access-plant {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
}
.container-access-plant > div {
  width: 100%;
  text-align: center;
}

.text-comeback {
  font-size: 12px;
  cursor: pointer;
  color: var(--ion-color-medium);
  vertical-align: middle;
}
.text-comeback:hover {
  text-decoration: underline;
  color: var(--ion-color-primary);
}
.text-comeback span {
  vertical-align: middle;
}

.container-connection-state {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
}
.container-connection-state ion-icon {
  display: inline-block;
  height: 18px;
  font-size: 19px;
  color: #fff;
}
.container-connection-state .connection-icon-container {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.container-connection-state .connection-icon-container.avaiable {
  background-color: var(--ion-color-primary);
}
.container-connection-state .connection-icon-container.not-avaiable {
  background-color: var(--ion-color-danger);
}
.container-connection-state .connection-icon-container.waiting {
  background-color: var(--ion-color-warning);
}
.container-connection-state .connection-state-text {
  display: inline-block;
  font-size: 14px;
  margin-left: 5px;
}

.container-form-login {
  width: 100%;
}

@media screen and (max-height: 720px) and (min-width: 1024px) {
  .container-access-plant {
    flex-direction: row;
    align-items: center;
    justify-content: center;
    min-height: calc(100vh - 56px);
  }
  img {
    width: 250px;
    height: 250px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/general components/login-access-plant/login-access-plant.component.scss","webpack://./src/components/general%20components/login-access-plant/login-access-plant.component.scss"],"names":[],"mappings":"AAEA;EACE,YAAA;EACA,eAAA;EACA,sBAAA;ACDF;;ADIA;EACE,gBATkB;EAUlB,cAAA;ACDF;;ADIA;EACE,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,sBAAA;ACDF;ADGE;EACE,WAAA;EACA,kBAAA;ACDJ;;ADKA;EACE,eAAA;EACA,eAAA;EACA,8BAAA;EACA,sBAAA;ACFF;ADIE;EACE,0BAAA;EACA,+BAAA;ACFJ;ADKE;EACE,sBAAA;ACHJ;;ADOA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;ACJF;ADME;EACE,qBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;ACJJ;ADOE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;ACLJ;ADOI;EACE,0CAAA;ACLN;ADQI;EACE,yCAAA;ACNN;ADSI;EACE,0CAAA;ACPN;ADUE;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;ACRJ;;ADYA;EACE,WAAA;ACTF;;ADYA;EACE;IACE,mBAAA;IACA,mBAAA;IACA,uBAAA;IACA,8BAAA;ECTF;EDYA;IACE,YAAA;IACA,aAAA;ECVF;AACF","sourcesContent":["$distanceButtonTop: 12px;\n\nion-icon {\n  height: 15px;\n  font-size: 16px;\n  vertical-align: middle;\n}\n\nion-text {\n  margin-top: $distanceButtonTop;\n  display: block;\n}\n\n.container-access-plant {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  flex-direction: column;\n\n  & > div {\n    width: 100%;\n    text-align: center;\n  }\n}\n\n.text-comeback {\n  font-size: 12px;\n  cursor: pointer;\n  color: var(--ion-color-medium);\n  vertical-align: middle;\n\n  &:hover {\n    text-decoration: underline;\n    color: var(--ion-color-primary);\n  }\n\n  span {\n    vertical-align: middle;\n  }\n}\n\n.container-connection-state {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n\n  ion-icon {\n    display: inline-block;\n    height: 18px;\n    font-size: 19px;\n    color: #fff;\n  }\n\n  .connection-icon-container {\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    &.avaiable {\n      background-color: var(--ion-color-primary);\n    }\n\n    &.not-avaiable {\n      background-color: var(--ion-color-danger);\n    }\n\n    &.waiting {\n      background-color: var(--ion-color-warning);\n    }\n  }\n  .connection-state-text {\n    display: inline-block;\n    font-size: 14px;\n    margin-left: 5px;\n  }\n}\n\n.container-form-login {\n  width: 100%;\n}\n\n@media screen and (max-height: 720px) and (min-width: 1024px) {\n  .container-access-plant {\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    min-height: calc(100vh - 56px);\n  }\n\n  img {\n    width: 250px;\n    height: 250px;\n  }\n}\n","ion-icon {\n  height: 15px;\n  font-size: 16px;\n  vertical-align: middle;\n}\n\nion-text {\n  margin-top: 12px;\n  display: block;\n}\n\n.container-access-plant {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  flex-direction: column;\n}\n.container-access-plant > div {\n  width: 100%;\n  text-align: center;\n}\n\n.text-comeback {\n  font-size: 12px;\n  cursor: pointer;\n  color: var(--ion-color-medium);\n  vertical-align: middle;\n}\n.text-comeback:hover {\n  text-decoration: underline;\n  color: var(--ion-color-primary);\n}\n.text-comeback span {\n  vertical-align: middle;\n}\n\n.container-connection-state {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n}\n.container-connection-state ion-icon {\n  display: inline-block;\n  height: 18px;\n  font-size: 19px;\n  color: #fff;\n}\n.container-connection-state .connection-icon-container {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.container-connection-state .connection-icon-container.avaiable {\n  background-color: var(--ion-color-primary);\n}\n.container-connection-state .connection-icon-container.not-avaiable {\n  background-color: var(--ion-color-danger);\n}\n.container-connection-state .connection-icon-container.waiting {\n  background-color: var(--ion-color-warning);\n}\n.container-connection-state .connection-state-text {\n  display: inline-block;\n  font-size: 14px;\n  margin-left: 5px;\n}\n\n.container-form-login {\n  width: 100%;\n}\n\n@media screen and (max-height: 720px) and (min-width: 1024px) {\n  .container-access-plant {\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    min-height: calc(100vh - 56px);\n  }\n  img {\n    width: 250px;\n    height: 250px;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
